import { makeid } from '../../constants';
import styles from '../../styles/common/table.scss';

interface BodyRowItem {
  rowItems: any[];
  onRowClick: () => void;
}

interface Props {
  itemtype: string;
  itemprop: string;
  title: string;
  headingData: any[];
  returnTimeHeading?: string;
  bodyData: any[];
  children: any;
  limit?: number;
  tableContainerBorder?: boolean;
  rowBottomBorder?: boolean;
  titleLowerCase?: boolean;
}

const AMCFundTableNew = (props: Props) => {
  const { itemtype, itemprop, title, bodyData, children, rowBottomBorder } =
    props;

  const limit = props.limit ? props.limit : bodyData.length;

  // const border =
  //   'lil-border-separate lil-w-full lil-shadow-sm lil-border-sm lil-rounded-xl lil-border-spacing-0 lil-border-grey-300 lil-mt-4';
  return (
    <div
      itemScope
      itemType={itemtype}
      className={`sm:lil-w-full sm:lil-pb-4 ${styles['sm-overflow-scroll']}`}
    >
      <h2 itemProp={itemprop} className="lil-hidden">
        {title}
      </h2>
      <table className={'lil-w-full'}>
        {/* <thead>
          <tr className={`${styles['bg-light-blue']}`}>
            {headingData.map(data => (
              <th
                className={`lil-text-left lil-py-4 lil-pl-4 sm:lil-pl-2 ${data.className}`}
                key={makeid()}
              >
                {' '}
                <p
                  className={data.textClass ? data.textClass : 'lil-text-s-14'}
                >
                  {titleLowerCase ? data.title : data.title.toUpperCase()}
                </p>
              </th>
            ))}
            {returnTimeHeading ? (
              <th className="lil-text-left lil-py-4 lil-pl-4 lil-pr-4">
                <p className="lil-text-s-14 ">{retunTime}</p>
              </th>
            ) : null}
          </tr>
        </thead> */}
        <tbody>
          {[...bodyData.slice(0, limit)].map((data: BodyRowItem) => (
            <tr
              className={`lil-cursor-pointer ${styles['hover-affect']} ${
                rowBottomBorder ? 'lil-border-b-sm lil-border-grey-250' : ''
              }`}
              onClick={data.onRowClick}
            >
              {data.rowItems.map((item) => (
                <td
                  className={`lil-py-4 lil-pl-4 lil-pr-4 lil-font-medium ${item.className}`}
                  key={makeid()}
                >
                  {item.component}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {children}
    </div>
  );
};

export default AMCFundTableNew;



// WEBPACK FOOTER //
// ./components/amc/amcFundTableNew.tsx